module.exports = __webpack_public_path__ + "8f403ae67a6730e0139820d1dead6aab.svg";